import { CommonModule } from "@angular/common";
import { NgModule, LOCALE_ID } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NgbCollapseModule, NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";

import { UIModule } from "../shared/ui/ui.module";
import { LayoutComponent } from "./layout.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { TopBarComponent } from "./topbar/topbar.component";
import { FooterComponent } from "./footer/footer.component";

import { MatBadgeModule } from "@angular/material/badge";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";

import { DateNowPipe } from "../core/pipes/date-now.pipe";

@NgModule({
  declarations: [LayoutComponent, TopBarComponent, NavbarComponent, FooterComponent, DateNowPipe],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    NgbCollapseModule,
    MatTooltipModule,
    UIModule,
    MatBadgeModule,
    MatProgressSpinnerModule
  ],
  providers: [{ provide: LOCALE_ID, useValue: "pt-BR" }]
})
export class LayoutsModule {}
